(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gr-autumn-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('gr-autumn-notice');
    if (!notice || typeof notice.showModal !== 'function') return;
    const expiry = Date.parse('2026-10-07T00:00:00+02:00');
    if (Date.now() >= expiry) return;
    const key = 'gr-autumn-notice-2026';
    notice.addEventListener('close', () => {
      try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    });
    const show = (rememberDismissal = true) => {
      if (rememberDismissal) {
        try { if (sessionStorage.getItem(key) === 'dismissed') return; } catch {}
      }
      if (Date.now() < expiry && !notice.open && !document.querySelector('dialog[open]')) {
        notice.showModal();
      }
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#gr-autumn-notice"]');
      if (!trigger) return;
      event.preventDefault();
      show(false);
    });
    if (notice.dataset.autoOpen === 'true') {
      if (document.readyState === 'complete') show();
      else window.addEventListener('load', () => show(), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
